import { useEffect, useRef, useState } from "react";
import RemboMark from "./RemboMark";
import "./css/brand_loader.css";

const DEFAULT_SIZE = { fullscreen: 72, overlay: 56, inline: 40 };

// Anti-flicker: never show for loads under `delay`ms, and once shown, stay
// visible at least `minDuration`ms so the loader itself doesn't flash.
export default function BrandLoader({
  show = true,
  variant = "fullscreen",
  label,
  size,
  delay = 150,
  minDuration = 400,
  className,
}) {
  const [visible, setVisible] = useState(false);
  const shownAtRef = useRef(null);
  const showTimerRef = useRef(null);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    if (show) {
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
        hideTimerRef.current = null;
      }
      if (!visible && !showTimerRef.current) {
        showTimerRef.current = setTimeout(() => {
          setVisible(true);
          shownAtRef.current = Date.now();
          showTimerRef.current = null;
        }, delay);
      }
    } else {
      if (showTimerRef.current) {
        clearTimeout(showTimerRef.current);
        showTimerRef.current = null;
      }
      if (visible) {
        const elapsed = Date.now() - (shownAtRef.current || 0);
        const remaining = Math.max(0, minDuration - elapsed);
        hideTimerRef.current = setTimeout(() => {
          setVisible(false);
          shownAtRef.current = null;
          hideTimerRef.current = null;
        }, remaining);
      }
    }
  }, [show, delay, minDuration, visible]);

  useEffect(
    () => () => {
      if (showTimerRef.current) clearTimeout(showTimerRef.current);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    },
    []
  );

  if (!visible) return null;

  const markSize = size || DEFAULT_SIZE[variant] || DEFAULT_SIZE.inline;

  return (
    <div
      className={`rl-loader rl-loader--${variant}${className ? ` ${className}` : ""}`}
      role="status"
      aria-live="polite"
    >
      <div className="rl-loader-mark-wrap" style={{ width: markSize, height: markSize }}>
        <span className="rl-loader-halo" />
        <span className="rl-loader-halo rl-loader-halo--delayed" />
        <RemboMark size={markSize} variant="solid" className="rl-loader-mark" />
      </div>
      {label && <div className="rl-loader-label">{label}</div>}
    </div>
  );
}
